import {
    GET_SUPPORT
  } from "../constant/user";
  
const initialState = {
  supportDetails: []
};


const SupportDetailReducer = (state=initialState,action)=>{
   
    const { type, payload } = action;

    switch(type){
        case GET_SUPPORT:
            return {...state, supportDetails: payload }
        default:
            return state;
    }
}

export default SupportDetailReducer;